import React, { useEffect, useState } from 'react';
import { Box, Typography, Alert, Modal, IconButton, Grid, Button, Link, Checkbox, Divider, CircularProgress } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { loadDepartments, loadReportingManagers, loadTeams } from '../../../redux/actions/lookups.action';
import CloseIcon from '@mui/icons-material/Close';
import Select from "react-select";
import { change_manager, change_team, profile_details, load_UserDetails } from '../../../redux/actions/user.actions'
import { SnackbarActions } from '../../../redux/actions/snackbar.actions'
import { fetchChartData2 } from '../../../redux/actions/structure.actions'
import { axiosFetch } from '../../../utils/AxiosFetch';
import { CustomStyles } from '../../../shared/DropdownCustomStyles';
import { SettingsCellSharp } from '@mui/icons-material';


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    bgcolor: 'background.paper',
    borderRadius: 3,
    // border: '1px solid #000',
    boxShadow: 24,
    p: 2,
};
function ChangeTeamModal(props) {
    const dispatch = useDispatch();
    const [open, setOpen] = React.useState(props.open);
    const [departmentOptions, setDepartmentOption] = useState([]);
    const [department, setDepartment] = useState("");
    const [managerOptions, setManagerOption] = useState([])
    const [manager, setManager] = useState("")
    // const [isTeam, setIsTeam] = useState(props.pageData.teamName);
    const [teamOption, setTeamOption] = useState([]);
    const [team, setTeam] = useState("");
    const [isManager, setIsManager] = useState(props.pageData.isManager);
    const [isAlternate, setIsAlternate] = useState(false);
    const [alterManager, setAlterManager] = useState("");
    const [isConfirm, setIsConfirm] = useState(false);
    const [altRepId, setAltRepId] = useState("");
    const [repManaErr, setRepManaErr] = useState(false);
    const [wholeTeam, setWholeTeam] = useState(false);
    const [moveAll, setMoveAll] = useState(false);
    const [loading, setLoading] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [isCheckbox, setIscheckbox] = useState(false);

    let LUDepartment = useSelector(state => state.loadDepartment_Reducer.departmentList)
    let LUManager = useSelector(state => state.loadReportingManagers_Reducer.managerList)
    let LUTeam = useSelector(state => state.loadTeam_Reducer.teamList)
    let changeManager_success = useSelector(state => state.changeManager_Reducer.changeManager)
    let changeTeam_success = useSelector(state => state.changeTeam_Reducer.changeTeam)



    const handleClose = () => {
        setOpen(false)
        props.handleClick()
        setIsAlternate(false)
    }
    useEffect(() => {
        changeTeam_success = ""
        if (props.open) {
            setRepManaErr(false)
            setOpen(true)
            setWholeTeam(false)
            var req = {
                "departmentId": props.pageData.departmentId,
                "teamId": props.pageData.teamId === null ? 0 : props.pageData.teamId,
                "userId": props.pageData.id

            }
            dispatch(loadDepartments());
            dispatch(loadReportingManagers(req));
            dispatch(loadTeams(props.pageData.departmentId))
            setIsManager(props.pageData.isManager)
        }
    }, [props])

    useEffect(() => {
        changeTeam_success = ""
        changeManager_success = ""
        var req = {
            "departmentId": props.pageData.departmentId,
            "teamId": props.pageData.teamId === null ? 0 : props.pageData.teamId,
            "userId": props.pageData.id

        }
        dispatch(loadDepartments());
        dispatch(loadReportingManagers(req));
        dispatch(loadTeams(props.pageData.departmentId))
    }, [])

    // useEffect(()=>{
    //     if(props.pageData.departmentId !== ""){
    //         dispatch(loadTeams(props.pageData.departmentId))
    //     }
    // },[props.pageData.departmentId])

    useEffect(() => {
        if (LUDepartment !== undefined) {
            setDepartmentOption(LUDepartment)
            if (props.pageData.departmentId !== "") {
                var value = [];
                LUDepartment.filter((option) => {
                    if (props.pageData.departmentId == option.value) {
                        value.push(option);
                    }
                    setDepartment(value)
                });
            }
        }
    }, [LUDepartment])

    useEffect(() => {
        if (LUManager !== undefined) {
            setManagerOption(LUManager)
            if (props.pageData.reportingPersonId !== "") {
                var value = [];
                LUManager.filter((option) => {
                    if (props.pageData.reportingPersonId === parseInt(option.value)) {
                        value.push(option);
                    }
                    setManager(value)
                });
            }
        }
    }, [LUManager])

    useEffect(() => {
        if (LUTeam !== undefined) {
            setTeamOption(LUTeam)
            if (props.pageData.teamId !== "") {
                var value = [];
                LUTeam.filter((option) => {
                    if (props.pageData.teamId === parseInt(option.value)) {
                        value.push(option);
                    }
                    setTeam(value)
                });
            }
        }
    }, [LUTeam])

    useEffect(() => {
        if (changeManager_success.data === "success") {
            setConfirmLoading(false)            
            if(props.from==="employeeList"){
                var req = {
                    Keyword: "",
                    Alphabet: null,
                    DepartmentName: "",
                    JobTitle: "",
                    Location: "",
                    ReportingManagerId: "",
                    IsActive: props.activeUsers,
                    Page: 1,
                    ResultsPerPage: 6,
                  };
                handleClose();
                dispatch(SnackbarActions(true, "success", "Alternate Manager has been updated successfully"))
                setIsConfirm(false)
            setIsManager(false)
            setIsAlternate(false)
            dispatch(load_UserDetails(req))

            }
            else{
            dispatch(profile_details(props.pageData.id))
            setIsConfirm(false)
            setIsManager(false)
            setIsAlternate(false)

            }
        }
    }, [changeManager_success])

    // useEffect(()=>{
    //     if(changeTeam_success.data === "success"){
    //         setOpen(false)
    //         dispatch(SnackbarActions(true,"success","User's team changed successfully"))
    //         // dispatch(fetchChartData(true));
    //     }
    // },[changeTeam_success])

    const handleDepartment = (selected) => {
        var name = [];
        name.push(selected);
        setDepartment(name);
        if (name[0].value !== "") {
            var id = name[0].value;
            var req = {
                "departmentId": id,
                "teamId": 0
            }
            setTeam("")
            dispatch(loadReportingManagers(req))
            dispatch(loadTeams(id))
        }
    }
    const handleTeam = (selected) => {
        var name = [];
        name.push(selected);
        setTeam(name);
        if (name[0].value !== "") {
            var teamId = name[0].value;
            var req = {
                "departmentId": parseInt(department[0].value),
                "teamId": parseInt(teamId),
            }
            setManager("")
            dispatch(loadReportingManagers(req))
        }
    }
    const handleManager = (selected) => {
        var name = [];
        name.push(selected);
        setManager(name);
        setRepManaErr(false)
    }
    const handleConfirm = () => {
        if (alterManager !== "") {
            setIsConfirm(true)
            setAltRepId(alterManager.value)
        }
    }
    const handleClickPopup = () => {
        var req = {
            "reportingManagerId": props.pageData.id,
            "newManagerId": altRepId
        }
        console.log(req);
        dispatch(change_manager(req));
        setConfirmLoading(true)
    };

    const handleChangeTeam = () => {
        setLoading(true);
        var teamId;
        if (team.length > 0) {
            teamId = team[0].value
        }
        else {
            teamId = null
        }
        if (manager.length > 0) {
            var req = {
                "userId": props.pageData.id,
                "departmentId": department[0].value,
                "teamId": teamId,
                "reportingPersonId": manager[0].value,
                "moveAll": moveAll,
            }
            dispatch(profile_details(props.pageData.id))
            //   dispatch(change_team(req))
            axiosFetch({
                method: 'POST',
                url: '/employees/team/update',
                requestConfig: req
            })
                .then((res) => {
                    if (res.status === 200) {
                        setLoading(false);
                        handleClose();
                        // setOpen(false)
                        dispatch(SnackbarActions(true, "success", "User's team changed successfully"))
                        dispatch(fetchChartData2(props.pageData.id));
                        if (props.userId !== undefined) {
                            dispatch(profile_details(props.userId))
                        }
                    }
                    if (res.status === 400) {
                        dispatch(SnackbarActions(true, "error", "Something Went Wrong!"))
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        }
        else {
            setRepManaErr(true)
        }
    }

    const handleCheckbox = (event) => {
        setWholeTeam(event.target.checked)
        if (event.target.checked === true) {
            setIsManager(false)
            setMoveAll(true)
            setIscheckbox(true)
        }
        else {
            setIscheckbox(false)
            setIsManager(true)
            setMoveAll(false)
        }
    }
    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            {isConfirm === false ?
                <Box sx={style}>
                    <Grid container spacing={2}>
                        {props.changeManager !== true ?
                            <><Grid xs={6} item>
                                <h3 className='modal-heading-team'>Change Team</h3>
                            </Grid>
                                <Grid xs={6} item>
                                    <IconButton size="small" style={{ float: "right" }} onClick={handleClose}>
                                        <CloseIcon color="secondary" fontSize="inherit" />
                                    </IconButton>
                                </Grid>
                                <Grid xs={12} item sx={{ paddingTop: "5px !important" }}>
                                    <hr />
                                </Grid>
                                <Grid xs={6} item>
                                    <h3 className='team-heading'>Department</h3>
                                    <Select
                                        placeholder="Select Department"
                                        name="Department"
                                        isDisabled={isManager && props.count > 0 ? true : false}
                                        value={department}
                                        options={departmentOptions}
                                        onChange={handleDepartment}
                                    />
                                </Grid>
                                <Grid xs={6} item>
                                    <h3 className='team-heading'>Team</h3>
                                    <Select
                                        placeholder="Select Team"
                                        name="Team"
                                        isDisabled={isManager && props.count > 0 ? true : false}
                                        value={team}
                                        options={teamOption}
                                        onChange={handleTeam}
                                    />
                                </Grid>
                                <Grid xs={12} item>
                                    <h3 className='team-heading'>Reporting Manager</h3>
                                    <Select
                                        placeholder="Select Reporting Manager"
                                        name="ReportingManager"
                                        value={manager}
                                        options={managerOptions}
                                        onChange={handleManager}
                                    />
                                    {repManaErr ? <p style={{ color: "red" }}>Reporting Manager is Required</p> : ""}
                                </Grid></> : ""}
                        <Grid item xs={12}>
                            {
                                (isManager && props.count) || isCheckbox  > 0 ?
                                    // <p>You couldn't change department &amp; team, because the user has {props.count} team members, Click <Link style={{ cursor:"pointer" }} size="small" onClick={()=>setIsAlternate(true) }>here</Link> to choose alternate team manager instead of existing one</p>
                                    <Alert severity="error">
                                        {/* <AlertTitle>Error</AlertTitle> */}
                                        <p className='team-para'><span style={{ fontWeight: "bold" }}>{props.pageData.firstName + " " + props.pageData.lastName}</span> manages <span style={{ textDecoration: "underline" }}>{props.count}</span> team members.
                                            To {props.from === "employeeList" ? "deactivate the user " : "change the department and/or team"} you need to move the individual team member(s).
                                            <Link style={{ cursor: "pointer" }} size="small" onClick={() => setIsAlternate(true)}> Click here </Link> to choose a new manager for the <span style={{ textDecoration: "underline" }}>{props.count}</span> direct reports.
                                            Alternatively, you can move the individual team member(s) one at a time to other managers if this is a multi-step organizational change.</p>
                                        
                                            {props.changeManager !== true?
                                            <div>
                                            <p style={{ textAlign: "center",margin:'0px', padding: "10px 0" }}><strong>OR</strong></p>
                                            <Divider />
                                            <Checkbox checked={wholeTeam} onChange={handleCheckbox} size="small" />Select the checkbox to change whole team members </div>:<></>
                                            }
                                            
                                    </Alert>
                                    : ""}
                        </Grid>
                        {isAlternate ?
                            <>
                                <Grid item xs={8} >
                                    <h3 className='team-heading'>Alternate Manager</h3>
                                    <Select
                                        placeholder="Select Alternate Manager"
                                        name="AlternateManager"
                                        value={alterManager}
                                        options={managerOptions}
                                        onChange={(selected) => setAlterManager(selected)}
                                        menuPortalTarget={document.body} menuPosition={'fixed'} 
                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    />
                                </Grid>
                                <Grid item xs={2} sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                    <Button style={{ marginTop: "20px" }} className='theme-btn' variant="contained" onClick={handleConfirm}>Save</Button>
                                </Grid>
                                <Grid item xs={2} sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                    <Button style={{ marginTop: "20px" }} className='theme-btn' variant="contained" onClick={() => setIsAlternate(false)}>cancel</Button>
                                </Grid>
                            </> : ""}
                        <Divider />
                        {props.changeManager !== true ? <Grid item xs={12} >
                            {loading?
                            <CircularProgress sx={{ float: "right", marginRight: 1 }} size="2rem" />:
                            <Button variant="contained" className='theme-btn' onClick={handleChangeTeam}>Submit</Button>}
                        </Grid> : ""}
                    </Grid>
                </Box> :
                <Box sx={style}>
                    <p>Are you sure to change the manager?</p>
                    <br />
                    <Button className='theme-btn cancel-btn' sx={{ marginLeft: "10px" }} onClick={() => setIsConfirm(false)}>no</Button>
                    {confirmLoading?
                            <CircularProgress sx={{ float: "right"}} size="2rem" />:
                            <Button className='theme-btn' onClick={handleClickPopup}>yes</Button>}
                </Box>}
        </Modal>
    )
}
export default ChangeTeamModal;